import React from 'react';
import {Link} from 'react-router-dom';
import './footer-css.css';

const Footer = () => (
    <div id="footer-div-1a">
        <div id="footer-div-2a">
            <ul className="footer-ul-1a">
                <li className="footer-li-1a">
                    <a href="https://www.crunchbase.com/organization/viral-inc#/entity" target="_blank">
                        <div className="footer-div-3a">
                            © Viral, Inc. 2017
                        </div>
                    </a>
                </li>
                <li className="footer-li-1a">
                    <a href="https://www.linkedin.com/company/viral-network" target="_blank">
                        <div className="footer-div-3a">
                            Linkedin
                        </div>
                    </a>
                </li>
            </ul>
            <ul className="footer-ul-1a">
                <li className="footer-li-1a">
                    <a href="https://twitter.com/agency" target="_blank">
                        <div className="footer-div-3a">
                            Twitter
                        </div>
                    </a>
                </li>
                <li className="footer-li-1a">
                    <a href="http://fb.me/ViralDigitalTalentTeam" target="_blank">
                        <div className="footer-div-3a">
                            Facebook
                        </div>
                    </a>
                </li>
            </ul>
            <ul className="footer-ul-1a">
                <li className="footer-li-1a">
                    <a href="mailto:go@viral.net" className="links-text">
                        <div className="footer-div-3a">
                            go@Viral.net
                        </div>
                    </a>
                </li>
                {/*<li className="footer-li-1a">*/}
                    {/*<Link to="/frequently.asked.questions" className="links-text" id="FAQ">*/}
                        {/*<div className="footer-div-3a">*/}
                            {/*FAQ*/}
                        {/*</div>*/}
                    {/*</Link>*/}
                {/*</li>*/}
            </ul>
            <ul className="footer-ul-1a">
                <li className="footer-li-1a">
                    <Link to="/terms.of.use" className="links-text" id="link-termsOfUse">
                        <div className="footer-div-3a">
                            Terms
                        </div>
                    </Link>
                </li>
                <li className="footer-li-1a">
                    <Link to="/privacy.policy" className="links-text" id="link-privacyPolicy">
                        <div className="footer-div-3a">
                            Privacy
                        </div>
                    </Link>
                </li>
            </ul>
        </div>
    </div>
);

export default Footer


// WEBPACK FOOTER //
// ./src/components/footer/Footer.js